import type { CollectionsQuery } from '~/generated/graphql';
import { CollectionGrid } from './CollectionGrid';
import { CollectionBentoGrid } from './CollentionBentoGrid';

type Collection = CollectionsQuery['collections']['items'][number];

interface CollectionListProps {
  collections: Collection[];
}

export function CollectionList({ collections }: CollectionListProps) {
  if (!collections) {
    return null;
  }

  const BENTO_COLLECTIONS = ['Home & Garden', 'Electronics'];
  return (
    <>
      {collections.map(
        (collection) =>
          collection.productVariants.items.length > 0 && (
            <div key={collection.id} className=" space-y-4">
              <div className=" flex justify-between items-baseline">
                <div className="flex">
                  <h2 className=" lg:text-4xl text-3xl font-semibold  px-3 lg:px-10 py-6 lg:py-8 tracking-tight  text-primary ">
                    {collection.name}
                  </h2>
                </div>
              </div>

              {BENTO_COLLECTIONS.includes(collection.name) ? (
                <CollectionBentoGrid
                  variants={collection.productVariants.items}
                  collectionName=""
                />
              ) : (
                <CollectionGrid
                  variants={collection.productVariants.items}
                  collectionName={collection.name}
                />
              )}
            </div>
          ),
      )}
    </>
  );
}
